export default __webpack_public_path__ + "static/media/instagram.b133e565.svg";